import { getAreaOfPolygon, getCenter, convertArea } from 'geolib'

import map from 'lodash/map'

const ALQ_FACTORS = {
  'acre': 0.000247104552407,
  'alsp': 0.0000413223140496,
  'almg': 0.0000206611570248
}

export const converAreaWithExtraUnits = (area, unit) => {
  if (['alsp', 'almg', 'acre'].includes(unit)) {
    return ALQ_FACTORS[unit] * area
  }

  return convertArea(area, unit)
}

export const getPolygonArea = (points, unit = 'm2') => converAreaWithExtraUnits(getAreaOfPolygon(points), unit)

export const getPolygonCenter = points => {
  const { latitude: lat, longitude: lng } = getCenter(points)

  return { lat, lng }
}

export const sortPolygonPoints = (points) => {
  const coordinates = map(points, ([latitude, longitude]) => ({ latitude, longitude }))

  coordinates.sort((a, b) => a.longitude - b.longitude)

  // Get center y
  const cy = (coordinates[0].longitude + coordinates[coordinates.length -1].longitude) / 2

  // Sort from right to left
  coordinates.sort((a,b) => b.latitude - a.latitude)

  // Get center x
  const cx = (coordinates[0].latitude + coordinates[coordinates.length -1].latitude) / 2

  // Center point
  const center = { latitude: cx, longitude: cy }

  // Pre calculate the angles as it will be slow in the sortnumround
  // As the coordinates are sorted from right to left the first point
  // is the rightmost

  // Starting angle used to reference other angles
  let startAng
  coordinates.forEach(point => {
    let ang = Math.atan2(
      point.longitude - center.longitude,
      point.latitude - center.latitude
    )
    if (!startAng) {
      startAng = ang
    } else if (ang < startAng) {  // ensure that all coordinates are clockwise of the start point
      ang += Math.PI * 2
    }
    // eslint-disable-next-line no-param-reassign
    point.angle = ang // add the angle to the point
  })

  // Sort;
  const response = coordinates.sort((a, b) => b.angle - a.angle)

  return map(
    response,
    ({ latitude, longitude }) => [latitude, longitude]
  )
}
